import { Link } from "react-router-dom";

export const Logo = ({ compact = false, className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="site-logo"
      aria-label="Hildreth Technologies LLC — Home"
      className={`group flex items-center gap-3 ${className}`}
    >
      <span
        className="relative flex h-10 w-10 items-center justify-center rounded-lg font-display text-lg font-extrabold tracking-tight text-white shadow-lg"
        style={{
          background:
            "linear-gradient(135deg, #0EA5E9 0%, #0D9488 100%)",
        }}
      >
        HT
      </span>
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="font-display text-[15px] font-semibold tracking-tight text-white">
            Hildreth Technologies
          </span>
          <span className="text-[11px] font-medium uppercase tracking-[0.22em] text-slate-400">
            LLC
          </span>
        </span>
      )}
    </Link>
  );
};
